import React from "react";

export default ({ model, processedColumns, runtimeProps = {} }) => (
    <tfoot>
        <tr>
            {processedColumns.map((c, i) => {
                if (c.customFooterCell) {
                    return <c.customFooterCell column={c} key={i} model={model} />;
                }

                return <th key={i} />;
            })}
        </tr>
    </tfoot>
);
